//src/api/user.js
import api from './index';


export const updateUserProfile = ({  username , uid  }) => api.post('/testapi/user/user_controller/update_name', {
  username , uid  // 发送 { uid: "some-uid-value" }
});

// api/user.js - 修改后的verifyGoogleLogin，保持原接口兼容
// api/user.js - 修改后的verifyGoogleLogin
export const verifyGoogleLogin = (params) => {
  // 处理authCode情况，转换为credential格式
  if (params.authCode) {
    // 记录调试信息
    console.log('授权码模式，转换为统一格式');
    
    // 使用后端期望的格式
    return api.post('/testapi/user/google_login_controller/auth/google/verify-v2', {
      credential: params.authCode,     // 重用credential参数名
      auth_type: 'code',               // 添加类型标识
      redirect_uri: params.redirectUri // 提供重定向URI
    });
  } 
  // 处理credential情况(JWT)
  else if (params.credential) {
    console.log('JWT凭证模式');
    
    // 使用原始调用方式
    return api.post('/testapi/user/google_login_controller/auth/google/verify-v2', {
      credential: params.credential,
      auth_type: 'jwt'                // 添加类型标识
    });
  }
  // 如果没有任何凭证
  else {
    // 返回一个已拒绝的Promise
    console.error('缺少凭证参数');
    return Promise.reject({
      success: false,
      message: '缺少凭证参数，需要提供credential或authCode'
    });
  }
};

export const getUserProfile = ({ uid }) => api.post('/testapi/user/user_controller/authing_login', {
  uid // 发送 { uid: "some-uid-value" }
});

const resolveDocmeeBasicAuth = () => {
  const fromEnv = process.env.REACT_APP_AIPPT_BASIC_AUTH;
  if (typeof fromEnv === 'string' && fromEnv.trim()) {
    return fromEnv.trim();
  }
  return 'Basic cG9kY2FzdGFpX2tJTkN0OmhCN1o4ZTVkcjNXeDhyVX4rPX4rPQ==';
};

export const getAipptToken = ({ uid }) =>
  api.post(
    '/testapi/user/user_controller/get_aippt_token',
    {
      uid
    },
    {
      headers: {
        Authorization: resolveDocmeeBasicAuth(),
        'Content-Type': 'application/json'
      }
    }
  );

export const deductAipptBalance = ({ user_key }) =>
  api.post('/testapi/diamond/diamond_check_controller/diamond_balance_update_ppt', {
    user_key
  });



// 新增接口：通过 url_login_token 获取用户信息
export const getUserProfileByToken = ({ url_login_token }) => api.post('/testapi/user/user_controller/login_by_token', { url_login_token });

export const login = ({ uid }) => api.post('/testapi/user/user_controller/authing_login', {
  uid // 发送 { uid: "some-uid-value" }
});

export const login_new = ({ uid }) => api.post('/testapi/user/user_controller/authing_login_new', {
  uid // 发送 { uid: "some-uid-value" }
});



export const getCaptcha = (email) => api.post('/testapi/user/stander_login_controller/send_email_for_login_aimonkey', {
  phoneNumbers: email
});


export const getSmsCaptcha = (email) => api.post('/testapi/user/login_controller/send_sms_for_login', {
  phoneNumbers: email
});

export const verifyCaptcha = ({ phoneNumbers, smsCode }) => api.post('/testapi/user/stander_login_controller/check_smscode_for_login', {
  phoneNumbers,
  smsCode
});

export const verifyPasswordLogin = ({ phoneNumbers, password }) => api.post('/testapi/user/stander_login_controller/check_password_with_auth', {
  phoneNumbers,
  password
});

// 修改密码
export const updatePassword = ({ phoneNumbers, password }) => api.post('/testapi/user/login_controller/update_password', {
  phoneNumbers,
  password
});

// 卡密激活
export const activateCard = ({ uid, card_code }) => api.post('/testapi/payment/card_controller/activate_card', {
  uid,
  card_code
});

// 获取AI图像生成历史记录
export const getImageHistory = ({ user_key }) => api.post('/testapi/conversation/conversation_controller/get_image_conversation', {
  user_key
});
